if ($('#formCambiaMutuo').length > 0) {

    var nResiduo;
    $(document).on("click","#residuo",function(){
        nResiduo = $(this).val();
        $(this).val("");
    });

    $(document).on("focusout","#residuo",function(){
        $(this).val(nResiduo);
    });

    $("#formCambiaMutuo").on("keyup","#residuo",function(){
        var prezzo = $(this).val();
        if(prezzo.indexOf(".") > 0){
            prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
        }
        prezzo = parseInt(prezzo) | "";
        prezzo = String(prezzo).replace(/(.)(?=(\d{3})+$)/g,'$1.')
        nResiduo = prezzo;
        $("#residuo").val(prezzo);
    });

    var nCostoMensile;
    $(document).on("click","#costo_mensile",function(){
        nCostoMensile = $(this).val();
        $(this).val("");
    });

    $(document).on("focusout","#costo_mensile",function(){
        $(this).val(nCostoMensile);
    });

    $("#formCambiaMutuo").on("keyup","#costo_mensile",function(){
        var prezzo = $(this).val();
        if(prezzo.indexOf(".") > 0){
            prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
        }
        prezzo = parseInt(prezzo) | "";
        prezzo = String(prezzo).replace(/(.)(?=(\d{3})+$)/g,'$1.')
        nCostoMensile = prezzo;
        $("#costo_mensile").val(prezzo);
    });

    $("#formCambiaMutuo").validate({
        ignore: [],
        focusInvalid: false,
        rules: {
            email: {
                required: true,
                verifyemail: true
            }
        }
    });

    $('#formCambiaMutuo').on('click', '#inviaCambiaMutuo', function () {
        
        var form   = $('#formCambiaMutuo');
        var action = form.attr('action');
        var data   = form.serialize();
        if ($(form).valid()) {
            $(this).prop("disabled", true);
            $.ajax({
                url: action,
                type: 'POST',
                data: data,
            })
            .done(function(data) {
                $(form)[0].reset();
                $('#inviaCambiaMutuo').prop("disabled", false);
                if (data.length > 0) {
                    $("#infoForm").html(data);
                    $("#infoForm").fadeIn("slow");
                }
            })
            .fail(function() {
                console.log("error");
            })
            .always(function() {
                console.log("complete");
            });
            
        }
    });
}
